var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":"https://k12.yunpengai.com/agreement.html","frameborder":"0"}})])
}]

export { render, staticRenderFns }